'use client';

import { createContext, PropsWithChildren, useContext } from 'react';

export type TClientEnvContext = {
  analyticCountId: string;
  instructionApiUrl: string;
  ML_SEARCH_TOKEN: string;
  basePath: string;
};

const ClientEnvContext = createContext<TClientEnvContext>({
  analyticCountId: '',
  instructionApiUrl: '',
  ML_SEARCH_TOKEN: '',
  basePath: '',
});
ClientEnvContext.displayName = 'ClientEnvContext';

export const ClientEnvProvider = ({
  clientEnvs,
  children,
}: PropsWithChildren<{ clientEnvs: TClientEnvContext }>) => (
  <ClientEnvContext.Provider value={clientEnvs}>
    {children}
  </ClientEnvContext.Provider>
);

export const useClientEnvContext = () => {
  const context = useContext(ClientEnvContext);

  if (!context) {
    throw new Error(
      'useClientEnvContext must be used within a ClientEnvContext, use ClientEnvProvider',
    );
  }

  return context;
};
